"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var S = _interopRequireWildcard(require("./Checkbox.style"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.439 6.035a1.445 1.445 0 0 0-2.02 0 1.39 1.39 0 0 0 0 1.988l5.613 5.524a1.59 1.59 0 0 0 2.222 0L19.582 2.4a1.39 1.39 0 0 0 0-1.988 1.445 1.445 0 0 0-2.02 0L7.141 10.664 2.44 6.035z"
  }));
};

CheckIcon.defaultProps = {
  fill: "currentColor",
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  xmlns: "http://www.w3.org/2000/svg"
};

var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      checked = _ref.checked,
      props = _objectWithoutProperties(_ref, ["className", "disabled", "onChange", "checked"]);

  return /*#__PURE__*/_react["default"].createElement(S.Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(S.Input, _extends({
    type: "checkbox",
    onChange: onChange,
    disabled: disabled,
    defaultChecked: checked,
    hidden: true
  }, props)), /*#__PURE__*/_react["default"].createElement(S.Checkbox, null, /*#__PURE__*/_react["default"].createElement(CheckIcon, null)));
};

Checkbox.propTypes = {
  className: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
Checkbox.defaultProps = {
  checked: false,
  disabled: false
};
var _default = Checkbox;
exports["default"] = _default;